import { render, staticRenderFns } from "./private_b_p.vue?vue&type=template&id=fa38be68&scoped=true"
import script from "./private_b_p.vue?vue&type=script&lang=js"
export * from "./private_b_p.vue?vue&type=script&lang=js"
import style0 from "./private_b_p.vue?vue&type=style&index=0&id=fa38be68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa38be68",
  null
  
)

export default component.exports